import Slider from 'react-slick';
import Spinner from '~/js/components/general/Spinner';
import LongReview from '~/js/components/global/reviews/LongReview';
import ReactNavDots from '~/js/components/global/ReactNavDots';

const { Component } = React;

class ReviewsModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      classNames: '',
      overview: '',
      reviews: [],
      startRow: 1,
      endOfTheLine: false,
      totalRecords: 9999,
      loadingOverview: true,
      loadingReviews: true
    };

    this.abortOverviewController = new window.AbortController();
    this.abortReviewsController = new window.AbortController();
    this.getReviewsRef = React.createRef();
  }

  componentDidMount() {
    this.mounted = true;
    const { resort } = this.props;

    this.timeoutId = setTimeout(() => {
      this.setState({
        classNames: 'open',
      });
    }, 250);

    const fetchOverview = (rstCode) => {
      fetch(`/fetchOverview/?resortCode=${rstCode}`, { signal: this.abortOverviewController.signal })
        .then((response) => response.json())
        .then((json) => {
          if(this.mounted) {
            this.setState({
              overview: json.data.resortOverview,
              loadingOverview: false
            });
          }
        })
        .catch((error) => {
          console.log(error.message);
          if(error.name === 'AbortError') {return;}
          throw error;
        });
    };

    fetchOverview(resort.code);
    this.fetchReviews(resort.code);

    this.getReviewsRef.current.addEventListener('click', this.fetchReviews);
    document.addEventListener('keydown', this.escapeKey, false);

  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.setState({
      classNames: [],
    });

    this.abortOverviewController.abort();
    this.abortReviewsController.abort();

    this.getReviewsRef.current.removeEventListener('click', this.fetchReviews);
    document.removeEventListener('keydown', this.escapeKey, false);
  }

  fetchReviews = () => {
    const { increment, resort } = this.props;
    const { startRow, totalRecords } = this.state;

    const reviewId = this.props.urlReviews.reviewId;

    this.setState({
      loadingReviews: true,
    });

    const url = reviewId != null || reviewId != undefined ?
    `/fecthReviews/?resortCode=${resort.code}&reviewId=${reviewId}&startRow=${startRow}&endRow=${startRow + increment}` :
    `/fecthReviews/?resortCode=${resort.code}&startRow=${startRow}&endRow=${startRow + increment}`
    fetch(url, { signal: this.abortReviewsController.signal })
      .then((response) => response.json())
      .then((json) => {
        this.setState(prevState => {
          const noMore = startRow + increment + 1 > totalRecords;
          const clickedReview = json.data.resortReviews.find(review => review.body === resort.body);
          const differentReviews = json.data.resortReviews.filter(review => review.body !== resort.body);
          let reorderedReviews = [clickedReview, ...differentReviews];


          if(typeof clickedReview !== 'undefined') {
            reorderedReviews = [clickedReview, ...differentReviews];
          }else{
            reorderedReviews = differentReviews;
          }

          return {
            reviews: [...prevState.reviews, ...reorderedReviews],
            startRow: startRow + increment + 1,
            totalRecords: json.data.resortReviews[0].totalRecords,
            endOfTheLine: noMore,
            loadingReviews: false,
          };
        });
      })
      .catch((error) => {
        console.log(error.message);
        if(error.name === 'AbortError') {return;}
        throw error;
      });
  };

    escapeKey = event => {
      if (event.keyCode === 27) {
        this.props.disableModal();
      }
    };

    render() {
      const { resort, disableModal, clickedReview } = this.props;
      const { classNames, overview, reviews, endOfTheLine, loadingOverview, loadingReviews } = this.state;

      const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        lazyLoad: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              dots: true,
              appendDots: dots => (
                <ReactNavDots
                  dots={dots}
                  dotWidth={15}
                  dotContainerClassName="slick-dots"
                />
              ),
            },
          },
        ],
      };

      return (
        <div className={`more-reviews ${classNames}`}>
          <div className="top-bar">
            <div className="container custom-container">
              <div className="row">
                <div className="xs-12">
                  <div className="flex">
                    <p>Guest Reviews</p>
                    <button onClick={() => disableModal()}>
                      <i className="icon-close" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="top-content">
            <div className="container">
              <div className="row">
                <div className="xs-12">
                  <div className="flex-info">
                    <div className="resort-info">
                      <div className="resort-slider">
                        <Slider {...settings}>
                          {resort.images.map((img, index) => {
                            return (
                              <img
                                key={index}
                                src={img}
                                alt="Resort Images"
                              />
                            );
                          })}
                        </Slider>
                        <p className="all-inclusive-stamp">
                        Family Friendly All-Inclusive
                        </p>
                      </div>
                      <div className="resort-overview">
                        <div className="resort-name">
                          <h2>{resort.name}</h2>
                          <h4>
                            {resort.city} -{' '}
                            {resort.country}
                          </h4>
                          <a href={resort.url}>View Resort{' '}
                            <img alt="link arrow" src="https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/link-arrow.svg" />
                          </a>
                        </div>

                        {!loadingOverview ? (
                          <div className="resort-review-overview">
                            <div className="rating-wrap">
                              <div className="stars-reviews">
                                <div className="star-wrap">
                                  <div className="base-stars">
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                  </div>
                                  <div
                                    className="real-stars"
                                    style={{width: `${overview.overallRating * 20}%`}}
                                  >
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                    <span className="stars">★</span>
                                  </div>
                                </div>
                              </div>

                              <p><strong>{overview.overallRating.toFixed(2)}</strong>{' '}Overall</p>
                            </div>
                            <div className="number-reviews">
                              <p>{overview.reviewCount}{' '} Verified Reviews</p>
                            </div>
                          </div>
                        ) : <Spinner className="reviews-modal__spinner" />}

                      </div>
                    </div>
                    <div className="more-reviews-wrap">
                      {reviews.map((review, index) => {
                        return (
                          <LongReview
                            clickedReview={clickedReview}
                            index={index}
                            key={`${review.rowNumber}-review`}
                            info={review}
                          />
                        );
                      })}
                      {loadingReviews && <div className="spinner" />}
                      <button ref={this.getReviewsRef} className={`view-more-reviews ${!loadingReviews && !endOfTheLine ? '' : 'hide'}`}>
                        View More Reviews{' '}
                        <img
                          alt="link arrow"
                          src="https://cdn.sandals.com/sandals/v12/images/general/all-inclusive/home-v2/down-arrow.svg"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
}

ReviewsModal.defaultProps = {
  increment: 5,
  brand: 'Beaches',
};

export default ReviewsModal;
